// @ts-nocheck

import { useState } from "react";
import { Link } from "react-router-dom";
import { List, Sidebar } from "@phosphor-icons/react";
import { dataSidebar } from "../utils/dataSidebar";
import useStore from "../store/useStore";
import LoggingService from "../services/LoggingService";

export function SideBar() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { user } = useStore((state) => state);

  // Filtra as seções do sidebar baseado no role do usuário
  const filteredSidebar = dataSidebar
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => {
        // Se o item não tem requiresRole, mostra para todos
        if (!item.requiresRole) return true;
        // Verifica se o usuário tem o role necessário
        return user.role.some((userRole) => item.requiresRole.includes(userRole));
      }),
    }))
    .filter((section) => section.items.length > 0); // Remove seções vazias

  const handleItemClick = (name: string, path: string) => {
    LoggingService.logSidebarClick(name, path);
  };

  return (
    <div
      className={`h-full dark:bg-gray-400 bg-gray-50 text-white transition-all duration-300 ease-in-out ${
        isCollapsed ? "w-20" : "w-52"
      }`}
    >
      <div className="pl-6 pt-2 pb-4 ">
        <button onClick={() => setIsCollapsed(!isCollapsed)} className="text-white">
          {isCollapsed ? (
            <Sidebar size={24} className="text-gray-100 hover:text-white" />
          ) : (
            <List size={24} className="text-gray-100 hover:text-white" />
          )}
        </button>
      </div>
      <nav className="">
        {filteredSidebar.map(({ title, items }, index) => (
          <div key={index} className="mb-2">
            <p className="text-sm font-thin pl-2 mb-1 text-gray-200">{title}</p>
            {items.map(({ name, icon, path }) => (
              <Link
                key={name}
                to={path}
                onClick={() => handleItemClick(name, path)}
                className="text-gray-200 flex items-center pl-5 hover:bg-gray-100 transition-colors duration-200 dark:hover:bg-gray-300"
              >
                <div className="flex items-center justify-center w-8">{icon}</div>
                <span
                  className={`ml-2 whitespace-nowrap overflow-hidden transition-all duration-300 ease-in-out ${
                    isCollapsed ? "w-0 opacity-0" : "w-auto opacity-100"
                  } tex-red-500`}
                >
                  {name}
                </span>
              </Link>
            ))}
          </div>
        ))}
      </nav>
    </div>
  );
}
